// --------------------------------------------------------------------------
// #TBC - Chart Generator
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function () {
    var graphColours = ['007ac9', '5a245a', 'fecb00', '6c7b1c', '414042', '46b6ff', 'a0409f', 'ffe785', 'bbd237', '8f8d91', '00568f', '481d49', 'b79301', '576416', '1f1e1f', 'addeff', 'cb7cca', 'fff7d6', 'dde89b', 'b8b6b9', '003152', 'e8c5e9', '665300', '93a626', 'e0e0e1'];

    return graphColours;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-graph-colours.js
// module id = 103
// module chunks = 0